
class Resources {
    APP_NAME = "";
    BACKEND_SIDE_BASE_URL = "https://api.geliverymm.com/safe-delivery-backend";//"https://api.gigagates.com/safe-delivery-backend";//
    BACKEND_SIDE_BASE_URL_2 = "https://api.geliverymm.com/safe-delivery-backend";//"https://api.gigagates.com/safe-delivery-backend";//
}

export default Resources;